import { useNuxtApp, useRequestEvent } from "#imports";
export function updateSiteConfig(input = {}) {
  if (process.server) {
    const stack2 = useRequestEvent().context.siteConfig;
    stack2.push(input);
    return;
  }
  const stack = useNuxtApp().$nuxtSiteConfig;
  stack.push(input);
}
